import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { UTruncateText } from './u-truncate-text.component';
import { TooltipModule } from 'primeng/tooltip';
import { UiInfraModule } from "../../ui-infra.module";
@NgModule({
  declarations: [UTruncateText],
  imports: [CommonModule, TooltipModule, UiInfraModule],
  exports: [UTruncateText],
})
export class UTruncateTextModule {}
